import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import SlideUpPopup from "../../../../generic/slideUpPopup";
import HoldMfUsablePopup from "./holdMfUsablePopup";

export interface IHoldMfUsableRowMobProps {
	rowData: any;
}

const HoldMfUsableRowMob: React.FC<IHoldMfUsableRowMobProps> = props => {
	const [isPopupOpen, setIsPopupOpen] = React.useState(false);

	return (
		<>
			<li className="data_row" onClick={() => setIsPopupOpen(true)}>
				<div className="row1">
					<div className="col trdSym">
						<span dangerouslySetInnerHTML={{ __html: props.rowData.scName }}></span>
					</div>
					<div className="col ltp">₹{toINR(props.rowData.amount, 2)}</div>
				</div>
				<div className="row2">
					<div className="col totQty">Total Qty: {toINR(props.rowData.hdgQty)}</div>
					<div className="col totQty">Used Qty: {toINR(props.rowData.usdQty)}</div>
				</div>
			</li>

			{isPopupOpen && (
				<SlideUpPopup closePopup={() => setIsPopupOpen(false)}>
					<HoldMfUsablePopup data={props.rowData} onClose={() => setIsPopupOpen(false)} />
				</SlideUpPopup>
			)}
		</>
	);
};

export default HoldMfUsableRowMob;
